import React from "react";
import * as Styles from "./NavigationSlider.styles";
import type { CarouselImageType } from "../../../../utils/types";
import { handleSlideButton } from "../../../../utils/sliderUtils";
import Button from "../../styles/atoms/Button";
import Icon from "../../styles/Icon";
import { useUscLabel } from "../../../../utils/labels";

export type NavigationSliderType = {
    images: CarouselImageType[];
    showArrowButtons: boolean;
    sharedSliderIndex: number;
    updateSharedSliderIndex: (index: number) => void;
    disableScroll: () => void;
};

const NavigationSlider = (props: NavigationSliderType): JSX.Element => {
    const { images, showArrowButtons, sharedSliderIndex, updateSharedSliderIndex, disableScroll } = props;

    const isFirstElement = sharedSliderIndex === 0;
    const isLastElement = sharedSliderIndex === images.length - 1;

    const [ariaSlideLabel, ariaSlidePreviousLabel, ariaSlideNextLabel] = useUscLabel([
        "uscAriaSlide",
        "uscAriaSlidePrevious",
        "uscAriaSlideNext",
    ]);

    return (
        <Styles.Slider onClick={disableScroll} show={images.length > 1} isFullScreen={showArrowButtons}>
            <Styles.SliderPositionWrapper>
                {images.map((_, index) => (
                    <Styles.SliderPosition // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        onClick={() => {
                            updateSharedSliderIndex(index);
                        }}
                        aria-label={`${ariaSlideLabel} ${index}`}
                    >
                        <Styles.SliderPositionBar active={index === sharedSliderIndex} />
                    </Styles.SliderPosition>
                ))}
            </Styles.SliderPositionWrapper>
            <Styles.SliderButtons hidden={!showArrowButtons}>
                <Button
                    variant="control"
                    disabled={isFirstElement}
                    onClick={() => {
                        updateSharedSliderIndex(handleSlideButton("left", sharedSliderIndex, images.length));
                    }}
                    aria-label={ariaSlidePreviousLabel}
                >
                    <Icon variant="chevron-left" />
                </Button>
                <Button
                    variant="control"
                    disabled={isLastElement}
                    onClick={() => {
                        updateSharedSliderIndex(handleSlideButton("right", sharedSliderIndex, images.length));
                    }}
                    aria-label={ariaSlideNextLabel}
                >
                    <Icon variant="chevron-right" />
                </Button>
            </Styles.SliderButtons>
        </Styles.Slider>
    );
};

export default NavigationSlider;
